'use strict'

const whechatLogin = {
    path:'/login',
    name:'app-login',
    meta: {
        title: '秀川结算-综合服务平台',
        code:''
    },
    component: () => import('@/pages/login/LoginByWeChatAndSMS'),
};

export default whechatLogin;
